<template>
  <span class="h-full aspect-square p-1 rounded-full mr-6 text-xs font-black"
    :class="{ 'bg-error': !LinkState, 'bg-success text-g0': LinkState }">
    4G
  </span>
  <slot v-if="LinkState"></slot>
</template>

<script>
export default {
  props: {
    config: Object
  },
  computed: {
    LinkState() {
      let wireless_link = this.config?.rcPlus?.status?.wireless_link != undefined
        ? this.config.rcPlus?.status?.wireless_link
        : false;

      if (!wireless_link) {
        return false
      }

      return wireless_link.hasOwnProperty('4g_gnd_link_state')
        ? wireless_link['4g_gnd_link_state'] == 1
        : false;
    },
  },
};
</script>
